export default __webpack_public_path__ + "static/media/Connector_Type3.6786dd9f.svg";